// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import StarRating from '../components/starRating';
// import '../styles/testimonialSlider.css';
// import '../styles/app.css';

// const testimonials = [
//   {
//     quote: "Very friendly group of pharmacists, great communication and they offer delivery services! We’ve had nothing but positive experiences dealing with them.",
//     author: "Chris Dinh",
//     rating: 5,
//     role: "Customer"
//   },
//   {
//     quote: "Cameron and the Mirror Lake Pharmacy team have been so great with me and my family! Always going above and beyond to help anyway they can.",
//     author: "Celina D.",
//     rating: 5,
//     role: "Customer"
//   },
//   {
//     quote: "Cam filled our prescriptions very quickly and was helpful with our insurance!",
//     author: "Chelsea P.",
//     rating: 5,
//     role: "Customer"
//   },
//   {
//     quote: "Great Pharmacist & excellent services! These guys provide walk in clinic services too! 100% recommended",
//     author: "Sahil Patel",
//     rating: 5,
//     role: "Customer"
//   }
// ];

// const TestimonialCarousel = () => {
//   return (
//     <section className="testimonials fade-in" id="testimonials">
//       <h2 className="slide-up">What Our Patients Say</h2>
//       <Swiper
//         modules={[Navigation, Pagination]}
//         navigation
//         pagination={{ clickable: true }}
//         loop={true}
//         className="testimonial-swiper slide-up"
//       >
//         {testimonials.map((item, index) => (
//           <SwiperSlide key={index}>
//             <div className="testimonial-slide-box fade-in">
//               <p className="testimonial-quote">{item.quote}</p>
//               <StarRating rating={item.rating} />
//               <p className="testimonial-author">
//                 <strong>{item.author}</strong>, {item.role}
//               </p>
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </section>
//   );
// };

// export default TestimonialCarousel;

// components/GoogleReviews.jsx
import React, { useEffect } from "react";
import "../styles/testimonialSlider.css"; // Optional styling

const TestimonialCarousel = () => {
  useEffect(() => {
    // Check if the script is already added
    if (!document.getElementById("featurable-script")) {
      const script = document.createElement("script");
      script.id = "featurable-script";
      script.src = "https://featurable.com/assets/v2/carousel_default.min.js";
      script.defer = true;
      script.charset = "UTF-8";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="testimonials fade-in">
      <div
        id="featurable-b666b621-bcf3-49d6-a14d-9531df44490a"
        data-featurable-async
      ></div>
    </section>
  );
};

export default TestimonialCarousel;
